<template>
  <div id="app">
    <div class="scroll-container">
      <iframe v-if="isStandalone" :src="App_URL" style="width: 100%; height: 100vh; border: none;"></iframe>
      <transition v-else>
        <RouterView />
      </transition>
    </div>
    <RegisterLoginPopup ref="registerRef" />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, provide, ref } from 'vue';
import RegisterLoginPopup from './view/loginRegister/registerLoginPopup.vue';
import { PWARewardAPI } from './api/user';
import { getPWADomainInfo } from './api/common';

const isStandalone = ref(false);
const App_URL = ref('')

onMounted(() => {
  // Detect standalone
  if (window.matchMedia("(display-mode: standalone)").matches) {
    isStandalone.value = true;
  } else if ((window.navigator as any).standalone) {
    // iOS Safari PWA
    isStandalone.value = true;
  }

  // React to changes
  window.matchMedia("(display-mode: standalone)")
    .addEventListener("change", (e) => {
      isStandalone.value = e.matches;
    });

  // 🔹 Detect PWA installation and refresh
  window.addEventListener("appinstalled", () => {
    console.log("✅ PWA was installed");
    window.location.reload(); // refresh app instantly
    if (localStorage.getItem('token') && localStorage.getItem('clientId')) {
      pwaCliam()
    }
    clearAuthData();
  });
});



const pwaCliam = () => {
  PWARewardAPI().then(res => {
    console.log("claim success: ", res);
    clearAuthData();
  }).catch(err => {
    console.log("claim err: ", err);
    clearAuthData();
  })
}


const getPWAInfo = () => {
  getPWADomainInfo().then(res => {
    let domain = res.data.websiteDomain
    if (domain && !domain.startsWith("http")) {
      domain = "https://" + domain
    }
    App_URL.value = domain
  }).catch(err => {
    console.log("claim err: ", err);

  })
};
const clearAuthData = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("clientId");
  localStorage.removeItem("tenantId");
};


onMounted(() => {
  getPWAInfo()
})
</script>

<style>
#app {
  position: fixed;
  width: 28rem;
  height: 100%;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  -webkit-transform: translate3d(-50%, 0, 0);
  overflow-x: hidden;
  overflow-y: hidden;
  background: #fff;
  background-size: cover;
  background-repeat: repeat;
}

@media (min-width: 1440px) {
  #app {
    width: 30rem;
  }
}

@media (min-width: 1920px) {
  #app {
    width: 35rem;
  }
}

.scroll-container {
  height: 100%;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.5s ease;
  position: absolute;
  width: 100%;
}

.slide-left-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-left-enter-to {
  transform: translateX(0%);
  opacity: 1;
}

.slide-left-leave-from {
  transform: translateX(0%);
  opacity: 0;
}

.slide-left-leave-to {
  transform: translateX(-30%);
  opacity: 0;
}

.ql-align-center {
  text-align: center;
}

.ql-align-right {
  text-align: right;
}

.ql-align-left {
  text-align: left;
}

@media screen and (max-width: 768px) {
  #app {
    width: 100%;
    left: 0;
    transform: none;
    -webkit-transform: none;
  }
}
</style>
